import styled from 'styled-components';

export const AuthWarpper = styled.section`
  .auth-box {
    width: 430px;
    margin: 1rem;
    &.register {
      width: 500px;
    }
  }
`;